import { QueryFunctionContext } from '@tanstack/react-query';
import { UseUserHasPassKeyQueryKeyProps } from './props';
import baseAPI from '@/api';
import { AxiosResponse } from 'axios';

export async function fetchUserHasPassKey({
  queryKey,
}: QueryFunctionContext<UseUserHasPassKeyQueryKeyProps>): Promise<boolean> {
  const { email } = queryKey[1];

  const response: AxiosResponse<boolean> = await baseAPI.get<boolean>(
    '/passkeys/user-has-passkey',
    {
      params: {
        email,
      },
    },
  );

  return response.data;
}
